<template>
	<div class="userList column-me">
		<div class="card-view column-me">
			<el-page-header @back="goBack" content="科目分类绑定"></el-page-header>
			<el-divider></el-divider>
			<div class="row-me row-center">
				<div class="row-me row-center">
					<div class="left-title">科目选择：</div>
					<div class="width400">
						<el-cascader
							class="width400"
							:options="subjectTableData"
							placeholder="请选择科目"
							:props="{ checkStrictly: true , emitPath:false }"
							clearable
							v-model="subjectSelected"
						></el-cascader>
					</div>
					<div class="left-title">分类选择：</div>
					<div class="width400">
					    <el-cascader
							class="width400"
					    	:options="classTableData"
					    	placeholder="请选择分类"
					    	:props="{ multiple: true, checkStrictly: true }"
							collapse-tags
					    	clearable
					    	v-model="classSelected"
					    ></el-cascader>
					</div>
					<el-button class="margin-left20" type="danger" size="mini" @click="subjectBindClassSave()">绑定</el-button>
				</div>
			</div>
			<el-divider></el-divider>
			<div class="column-me flex1 overflow-auto">
				<el-table 
					:data="tableData"
					v-loading="tableload"
					style="width: 100%;margin-bottom: 20px;"
					row-key="id"
					border 
					default-expand-all 
					:tree-props="{children: 'children', hasChildren: 'hasChildren'}"
				>
				    <el-table-column prop="tc_subject_id" label="科目ID" width="180"></el-table-column>
				    <el-table-column prop="tc_subject_title" label="科目" width="180"></el-table-column>
					<el-table-column prop="tc_spe_sub_id" label="分类ID" width="180"></el-table-column>
				    <el-table-column prop="tc_spe_sub_title" label="分类"></el-table-column>
				</el-table>
			</div>
		</div>
	</div>
	
</template>
<script>
import {Plus,Search} from "@element-plus/icons";
export default {
	components: {Plus,Search},
	data() {
		return {
			tableload:false,
			tableData:null,
			classTableData:null,
			classSelected:null,
			subjectTableData:null,
			subjectSelected:null,
		}
	},
	// 侦听器
	watch: {},
	// 计算属性
	computed: {
		
	},
	// html加载完成之前
	created() {
		this.getClassifyData();
		this.getSubjectData();
		this.getTableData();
	},
	// html加载完成后执行。
	mounted() {

	},
	// 事件方法执行
	methods: {
		//返回
		goBack() {
		    this.$router.go(-1)
		},
		//分类数据获取
		getClassifyData(){
			this.$post('/admin/specialSubList').then((res) => {
				if (res) {
					//console.log(res);
					this.classTableData = res.data;
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		//科目数据获取
		getSubjectData(){
			this.$post('/admin/systemSubjectInfo').then((res) => {
				if (res) {
					//console.log(res);
					this.subjectTableData = res.data;
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		//科目分类信息绑定提交
		subjectBindClassSave(){
			var classRess = [];
			if(this.subjectSelected === null){
				this.$message.warning('请选择科目');
				return;
			}
			if(Array.isArray(this.classSelected)){
				this.classSelected.forEach(function(e){
					classRess.push(e[e.length - 1]);
				});
			}else{
				this.$message.warning('请选择分类');
				return;
			}
			this.$post('/admin/systemSubjectClassBind',{
				subject_id:this.subjectSelected,
				speclass_arr:classRess,
			}).then((res) => {
				if (res) {
					this.classSelected = null;
					this.subjectSelected = null;
					//刷新下方表格
					this.getTableData();
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		//table表格数据获取
		getTableData(){
			this.tableload = true;
			this.$post('/admin/systemSubjectClassList').then((res) => {
				if (res) {
					console.log(res);
					this.tableData = res.data;
					this.tableload = false;
				}
			}).catch((error) => {
				console.log(error)
			})
		}
	},
}
</script>

<style lang="scss" scoped>
.userList {
  height: 100%;

  .img-header {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
}
</style>
